import type { ReactElement } from "react";

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use ActionMenu instead.
 */
export type MenuItems = {
  action?: VoidFunction;
  href?: string;
  icon?: ReactElement;
  title: string;
  type?: MenuItemType;
};

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use ActionMenu instead.
 */
export enum MenuItemType {
  Button = "button",
  Link = "link",
}
